import { render } from "./Settings.vue?vue&type=template&id=4fd5981a&scoped=true"
import script from "./Settings.vue?vue&type=script&lang=js"
export * from "./Settings.vue?vue&type=script&lang=js"

import "./Settings.vue?vue&type=style&index=0&id=4fd5981a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4fd5981a"

export default script